import { inject, Injectable } from "@angular/core";
import {
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { SnackbarService } from "@core/services/snackbar.service";
import { RutaDinamicaService } from "@shared/services/ruta-dinamica.service";

@Injectable({
  providedIn: "root",
})
export class PermissionGuard implements CanActivateChild {
  private snackbar = inject(SnackbarService);
  private rutaDinamicaService = inject(RutaDinamicaService);
  private router = inject(Router);

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const menuCache = this.rutaDinamicaService.getMenuUsuario();

    if (menuCache) {
      return of(this.checkPermissions(menuCache, state.url));
    }

    return this.rutaDinamicaService.fetchMenuUsuario().pipe(
      map((menu) => {
        if (!menu) {
          this.snackbar.error("Error al verificar permisos");
          this.router.navigate(["/dashboard"]);
          return false;
        }
        return this.checkPermissions(menu, state.url);
      })
    );
  }

  private checkPermissions(menu: any, url: string): boolean {
    const pathUsuario = menu?.lista?.map((item: any) => this.normalizarPath(item.path)) ?? [];
    const pathActual = this.normalizarPath(url);
    const tienePermiso = pathUsuario.some((rutaPermitida: string) =>
      pathActual.startsWith(rutaPermitida)
    );

    if (!tienePermiso) {
      this.snackbar.error("Permisos insuficientes para acceder a esta ruta");
      this.router.navigate(["/dashboard"]);
      return false;
    }
    return true;
  }

  private normalizarPath(path: string): string {
    return path
      .replace(/^\/+|\/+$/g, "")
      .replace(/^modulos\//, "")
      .split("?")[0]
      .split(";")[0]
      .toLowerCase();
  }
}
